<script>

    import SidePanel from "./canvasUtils/SidePanel.svelte";
    import MainCanvas from "./canvasUtils/MainCanvas.svelte";

    export const hideItself = (shouldHide) => {
        if (shouldHide){
            canvasDiv.style.display = "none";
            warningView.style.display = "none";
        }
        else{
            canvasDiv.style.display = "flex";
            if (childReference != null){
                childReference.resizeToHolder();
            }
        }
    }
    let canvasDiv;
    let warningView;

    let childReference;

</script>



<div class="contentBox" id="canvasTop" bind:this={canvasDiv}>


    <MainCanvas bind:this={childReference}/>

    <SidePanel/>
    
   

</div>


<div class="contentBox" id="screenWarning" bind:this={warningView}>
    <h1>No support for your screen!</h1>
    <h4>Sorry, try getting here on something with a bigger screen</h4>

</div>

<style>

    #canvasTop{
        display: flex;
        overflow: scroll;
    }

    #screenWarning{
        display: none;
    }

    @media (orientation: portrait) {
        #canvasTop {
            display: none;
        }

        #screenWarning{
            display: block;
        }
    }


</style>